/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { Typography } from "../Typography";
import { Flex } from "../utilities";
import { Checkbox } from "./Checkbox";
import { checkboxLabelCSS } from "./Checkbox.css";
import type { CheckboxLabelProps } from "./Checkbox.types";

export const CheckboxLabel = ({
  children,
  iconPosition = "left",
  label,
  text,
  sx,
  ...checkboxProps
}: CheckboxLabelProps) => {
  const deprecatedLabel = label || text;

  return (
    <Flex
      as="label"
      alignItems="center"
      gap={vars.spacing[1]}
      native={{
        "data-checkbox-icon_position": iconPosition,
      }}
      css={[checkboxLabelCSS({ iconPosition }), sx]}
    >
      {children || <Checkbox {...checkboxProps} />}

      {deprecatedLabel && (
        <Typography
          variant="label-medium"
          native={{
            "data-checkbox-label": true,
          }}
        >
          {deprecatedLabel}
        </Typography>
      )}
    </Flex>
  );
};
